import { formatMoney } from '@/lib/utils';
import type { PayrollOwedVisitDto } from '@/lib/api/payroll';

import { formatDate } from '../../jobs/helpers';

interface Props {
  visit: PayrollOwedVisitDto;
  selected: boolean;
  onToggle: (visitId: string) => void;
}

export function VisitRow({ visit, selected, onToggle }: Props) {
  return (
    <label
      className="flex items-center gap-3 px-4 py-3 rounded-xl border bg-card cursor-pointer"
      data-testid={`payroll-visit-row-${visit.job_visit_employee_id}`}
    >
      <input
        type="checkbox"
        checked={selected}
        onChange={() => onToggle(visit.job_visit_employee_id)}
        className="w-4 h-4 shrink-0"
        data-testid={`payroll-visit-checkbox-${visit.job_visit_employee_id}`}
      />
      <div className="flex-1 min-w-0">
        <p className="text-sm font-medium">{formatDate(visit.scheduled_date)}</p>
      </div>
      <p className="text-sm font-semibold shrink-0">{formatMoney(visit.pay_amount)}</p>
    </label>
  );
}
